/**
 * @generated SignedSource<<fc188d869b69d8be492d3aa31441d9b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerOnelineMenuStyleQuery$data = {
  readonly styleOnelineMenu: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "sectionStyleHeaderMenuItem">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "headerOnelineMenuStyleQuery";
};
export type headerOnelineMenuStyleQuery$key = {
  readonly " $data"?: headerOnelineMenuStyleQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerOnelineMenuStyleQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerOnelineMenuStyleQuery",
  "selections": [
    {
      "alias": "styleOnelineMenu",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "scmp_pwa_oneline_menu_style"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "entityLink"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sectionStyleHeaderMenuItem"
                        }
                      ],
                      "type": "Section",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:100)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"scmp_pwa_oneline_menu_style\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a9efe105adcc11a97565e5e6cd1a03dd";

export default node;
